import type { Weight, WeightInput } from '@nucleus-commerce/api-client/admin';

import type { WeightFieldInput, WeightFieldOutput } from '../schemas/weight-schema';

/** Only `weight` is sent; the backend derives `weightGrams` from it (D-141). */
export function toWeight(field: WeightFieldOutput): WeightInput | null {
  return field.value === '' ? null : { value: Number(field.value), unit: field.unit || 'g' };
}

export function fromWeight(weight: Weight | null): WeightFieldInput {
  return weight === null
    ? { value: '', unit: '' }
    : { value: String(weight.value), unit: weight.unit };
}
